import * as React             from 'react';
import * as cx                from 'classnames';
import icons                  from '../../icons';

const handleSearch = (callback, event: React.KeyboardEvent<{ value: string }>) => callback(event.currentTarget.value);

const SearchComponent = (props) => {
    const regularLabel = props.label + '__search';

    return (
        <div className={cx(regularLabel)}>
            <div className="container">
                {icons.search}
                <input
                    onChange={handleSearch.bind(null, props.setSearchValue)}
                    placeholder={props.placeholder}
                    value={props.searchValue}
                />
            </div>
        </div>
    );
};

export default SearchComponent;



// WEBPACK FOOTER //
// ./src/sections/ConversationsList/SearchInput.tsx